export const projects = [
  {
    name: 'RGA Website',
    tools: 'React | TailwindCSS | Nodemailer',
    description: 'The official website for Robert Guild Associates, showcasing services and capabilities.',
    repoUrl: 'https://github.com/alialoraebi/rga-website',
  },  
  {
    name: 'RGA Document Management System',
    tools: 'React | Node.js | TailwindCSS | AWS | MongoDB',
    description: 'A comprehensive web application for document management and inventory tracking, enabling secure document storage and inventory control.',
  },    
  {
    name: 'RGA Maintenance & Reporting Platform',
    tools: 'React | Node.js | TailwindCSS | AWS | MongoDB',
    description: 'A tool for tracking and storing maintenance requests and reports.',
  },
  {
    name: 'F1 23 Results App',
    tools: 'React | TailwindCSS | Node.js | Express.js | MongoDB',
    description: 'A React web application that allows F1 23 players to add their own race results and compare it with real racers.',
    repoUrl: 'https://github.com/alialoraebi/F1_23_App',
  },
  {
    name: 'Digital Divide',
    tools: 'Python',
    description: 'A Python project that focuses on understanding the impact of the digital divide within Canada.',
    repoUrl: 'https://github.com/alialoraebi/digital-divide',
  },
];